<template lang="pug">
    .component.ticket-print.tp
        .tp__number__container
            label Место
            .tp__number
                .tp__number__item
                    input(type="number" min="1" max="999" v-model="from" v-on:input="changeFrom")
                .tp__number__item_devider
                .tp__number__item
                    input(type="number" min="1" max="999" v-model="to" v-on:input="changeTo")
        .tp__btn-container(ref="btn")
            .tp__btn
                .tp__btn-content(v-on:click="print")
                    md-icon print
                    span Печать
                .arrow(v-on:click="togglePrinters")
                    svg(height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg")
                        path(d="M7 10l5 5 5-5z")
                        path(d="M0 0h24v24H0z" fill="none")
            transition(name="fade")
                .tp__btn-list(v-show="show" v-bind:class="{'active': show}")
                    .tp__btn-list__item(v-for="printer in printers" v-on:click="setDefaultPrinter(printer)" v-bind:class="{'selected': (defaultPrinter && parseInt(defaultPrinter.id) == printer.id)}")
                        i.fa.fa-check
                        span {{printer.ip + ' (' + printer.name + ')'}}
                    .tp__btn-list__item(v-on:click="setDefaultPrinter(browserPrinter)" v-bind:class="{'selected': (defaultPrinter && defaultPrinter.id == 'browser')}") 
                        i.fa.fa-check
                        span Браузер
</template>
<script>
    import moment from "moment";
    import QRCode from "qrcode";
    export default {
        components: {QRCode},
        props: {
            printers: {
                type: Array,
                default: []
            },
            trackingNumber: {
                type: String,
                default: ''
            },
            date: {
                type: String,
                default: ''
            },
            fromCity: {
                type: String,
                default: ''
            },
            toCity: {
                type: String,
                default: ''
            },
            fromAddress: {
                type: String,
                default: ''
            },
            toAddress: {
                type: String,
                default: ''
            },
            seatsNumber: {
                type: Number,
                default: 0
            },
            sender: {
                type: String,
                default: ''
            },
            recipient: {
                type: String,
                default: ''
            },
            dataCallback: {
                type: Function,
                default: null
            },
            temperatureRegime: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                show: false,
                blurListener: null,
                from: 1,
                to: 1,
                defaultPrinter: null,
                browserPrinter: {
                    id: 'browser',
                    ip: 'browser',
                    name: "Браузер",
                    port: null,
                    status_id: 1,
                    stock_id: null,
                }
            }
        },
        watch: {
            //Отключено чтобы пользователь не мог печатать произвольные этикетки
            'seatsNumber'(seatsNumber) { this.to = this.seatsNumber; }
        },
        computed: {
            fromCityShort() {
                let value = this.$props.fromCity;
                if (value.length <= 18) return value;

                let separator = value.indexOf('-');
                if (!(+1)) separator = value.indexOf(' ');
                if ((separator+1) && separator <= 18) value = value.slice(0, separator) + '\n' + value.slice(separator);
                
                return value;
            },
            toCityShort() {
                let value = this.$props.toCity;
                if (value.length <= 18) return value;

                let separator = value.indexOf('-');
                if (!(+1)) separator = value.indexOf(' ');
                if ((separator+1) && separator <= 18) value = value.slice(0, separator) + '\n' + value.slice(separator);
                
                return value;
            },
        },
        methods: {
            changeFrom() {
                if (!this.from) return;
                if (this.from > this.to || this.from > this.$props.seatsNumber) this.from = 1;
            },
            changeTo() {
                if (!this.to) return;
                if (this.to < this.from || this.to > this.$props.seatsNumber) this.to = this.$props.seatsNumber;
            },
            togglePrinters() {
                this.show = !this.show;
            },
            setDefaultPrinter(printer) {
                this.defaultPrinter = Object.assign({}, printer);
                localStorage.setItem('defaultPrinter', JSON.stringify(printer));
                this.show = false;
            },
            getDefaultPrinter() {
                let defaultPrinter = localStorage.getItem('defaultPrinter');
                if (defaultPrinter) this.defaultPrinter = Object.assign({}, JSON.parse(defaultPrinter));
                return this.defaultPrinter;
            },
            listeners() {
                this.blurListener = document.addEventListener('click', e => {
                    if (this.$refs && this.$refs.btn && !this.$refs.btn.contains(e.target)) this.show = false;
                });
            },
            getZebraTemplate(i) {
                return ("^CWZ,E:TT0003M_.FNT^FS" +
                    "^FO26,30^CI28^AZN,26,26^FD№:^FS" +
                    "^FO66,30^CI28^AZN,26,26^FD" + this.$props.trackingNumber + "^FS" + (this.to ? ("^FO480,30^CI28^AZN,26,26^FD" + i + " из " + this.to + "^FS") : '') +

                    "^FO26,73^CI28^AZN,26,26^FDДата приема^FS" +
                    "^FO26,100^CI28^AZN,26,26^FD" + (this.$props.date ? this.$props.date : '--') + "^FS" +

                    "^FO26,130^CI28^AZN,26,26^FDОтправление^FS" +
                    "^FO26,157^CI28^AZN,26,26^FD" + (this.fromCityShort ? this.fromCityShort : '--') + "^FS" +

                    "^FO26,204^CI28^AZN,26,26^FDНазначение^FS" +
                    "^FO26,231^CI28^AZN,26,26^FD" + (this.toCityShort ? this.toCityShort : '--') + "^FS" +

                    "^FO26,285^CI28^AZN,26,26^FDПолучатель^FS" +
                    "^FO26,312^CI28^AZN,26,26^FD" + (this.$props.recipient ? this.$props.recipient : '--') + "^FS" +

                    (this.$props.temperatureRegime ? '"^FO26,366^CI28^AZN,26,26^FDТемп. режим^FS"' : '') + 

                    "^FO12,14^GB568,393,8^FS\n" +
                    "^FO12,62^GB565,0,8^FS\n" +
                    "^FO291,62^GB0,314,8^FS\n" +
                    "^FT335,353^BQN,2,10\n" +
                    "^FH\\^FDLA," + (this.$props.trackingNumber + '/' + i) + "^FS");
            },
            async printByPrinter(printer) {
                let header = '^XA\n', footer = '^XZ', message = '';
                for (let i = this.from; i <= parseInt(this.to); i++) {
                    message = (header + this.getZebraTemplate(i) + footer);
                    await this.httpPrint('//' + printer.ip + ':' + printer.port + '/pstprnt', message);
                }
            },
            httpPrint(url, body, callback) {
                return fetch(url, {
                    method: 'POST',
                    mode: 'no-cors', 
                    cache: 'no-cache', 
                    body: body,
                    headers: {'Content-Type': 'text/plain'}
                }).then(r => {
                    console.log(r);
                }).catch(e => {
                    console.warn('Fetch 1 error: ' + e.message);
                });
                

                /*
                return new Promise(resolve => {
                    var xmlHttp = new XMLHttpRequest();
                    xmlHttp.onreadystatechange = function() {
                        if (xmlHttp.readyState == 4) {
                            //if (xmlHttp.status == 200) callback(xmlHttp.responseText);
                            //else console.log('Error: ');
                            resolve();
                        }
                    }
                    xmlHttp.mode = '';
                    xmlHttp.open("POST", url, true);
                    xmlHttp.setRequestHeader('Content-Type', 'text/plain');
                    xmlHttp.send(body);
                    setTimeout(() => {
                        xmlHttp.abort();
                        resolve();
                    }, 5000);
                });
                */
            },
            async print() {
                try {
                    if (!this.defaultPrinter) {
                        this.show = true;
                        return;
                    }

                    if (this.$props.dataCallback) await this.$props.dataCallback();
                    if (!this.defaultPrinter.id || this.defaultPrinter.id == 'browser') this.browserPrint();
                    else this.printByPrinter(this.defaultPrinter);
                } catch(e) {
                    this.$store.commit('showSnackbar', ['Ошибка печати, попробуйте ещё раз или выберите другой способ печати', 6000, 'error']);
                }
            },
            async browserPrint() {
                this.setDefaultPrinter(this.browserPrinter);
                let ticketsPrintData = {
                    freight_tracking:  this.$props.trackingNumber,
                    created_at:        this.$props.date,
                    from_city:         this.$props.fromCity,
                    to_city:           this.$props.toCity,
                    seats_number:      this.$props.seatsNumber,
                    recipient:         this.$props.recipient,
                    sender:            this.$props.sender,
                    temperatureRegime: this.$props.temperatureRegime,
                    from:              this.from,
                    to:                this.to
                };
                
                let route = this.$router.resolve({ name: 'FreightPrintTicket', query: { data: JSON.stringify(ticketsPrintData)}});
                window.open(route.href, '_blank', 'height=720,width=1280');
                this.show = false;
            }
        },
        created() {
            this.$nextTick(() => {
                this.listeners();
                this.to = parseInt(this.seatsNumber);
                this.getDefaultPrinter();
            });
        }
    }
</script>
<style lang="sass">
.ticket-print
    display: flex
    align-items: center
    justify-content: flex-start
    margin: 0 8px
    .temp-regime
    .tp__number__container
        display: flex
        align-items: center
        justify-content: flex-start
        label
            display: block
            margin: 0 10px 0 0
            font-size: 14px
            line-height: 14px
        .tp__number
            display: flex
            align-items: center
            justify-content: center
            width: 140px
            margin: 0 4px 0 0
            border: 1px solid rgba(0, 0, 0, 0.42)
            height: 34px
            border-radius: 3px
            .tp__number__item_devider
                width: 12px
                height: 2px
                background: rgba(0, 0, 0, 0.42)
            .tp__number__item
                display: flex
                align-items: center
                justify-content: center
                width: calc(50% - 6px)
                label
                input
                    -webkit-appearance: none !important
                    -moz-appearance: textfield
                    font-size: 14px
                    text-align: center
                    width: calc(100% - 5px)
                    height: 26px
                    border: 0
                    border-radius: 3px
                    outline: none !important
                    background: #eaeaea
                    &::-webkit-outer-spin-button, &::-webkit-inner-spin-button
                        -webkit-appearance: none
                        margin: 0
    .tp__btn-container
        position: relative
        .tp__btn
            display: flex
            align-items: center
            justify-content: flex-start
            position: relative
            width: 160px
            height: 34px
            padding: 0 8px
            border: 1px solid rgba(0, 0, 0, 0.42)
            border-radius: 3px
            cursor: pointer
            .tp__btn-content
                display: flex
                align-items: center
                justify-content: flex-start
                width: calc(100% - 32px)
                height: 100%
                .md-icon
                    margin: 0
                span
                    padding: 0 5px
            .arrow
                display: flex
                align-items: center
                justify-content: center
                position: absolute
                z-index: 1
                direction: ltr
                font-family: Material Icons
                width: 32px
                height: 32px
                font-size: 24px !important
                margin: auto
                right: 0
                top: 0
                border-left: 1px solid rgba(0, 0, 0, 0.42)
        .tp__btn-list
            position: absolute
            bottom: 34px
            background: #fff
            border-radius: 3px
            z-index: 20
            box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)
            overflow-x: hidden
            overflow-y: auto
            min-width: 220px
            max-width: 280px
            max-height: 35vh
            .tp__btn-list__item
                min-height: 30px
                padding: 4px 16px 4px 20px
                font-size: 13px
                line-height: 15px
                display: flex
                align-items: center
                justify-content: flex-start
                cursor: pointer
                &:hover
                    background-color: var(--md-theme-white-divider-on-background, rgba(0, 0, 0, 0.12));
                &.selected
                    svg
                        display: block
                        margin: 0 5px 0 -15px
                        width: 10px
                svg
                    display: none
                    
</style>


// WEBPACK FOOTER //
// TicketPrint.vue?3777e201